// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalEligibilityDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalEligibilityDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalEligibilityDefaultResponse.discriminator = undefined;
MedicalV1MedicalEligibilityDefaultResponse.additionalProperties = false;
MedicalV1MedicalEligibilityDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalEligibilityDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalEligibilityDefaultResponse.js.map